export function formatPrice(amount, priceProperties) {
  let properties = {
    showSymbol: false,
    currency: 'USD',
    symbol: '$',
    format: 2,
    negative: false,
    plus: false,
  };

  if (typeof amount !== 'number') {
    return '';
  }

  properties = { ...properties, ...priceProperties };

  const { format, negative, plus } = properties;

  if (properties.showSymbol) {
    return `${negative ? '-' : ''}${properties.symbol}${amount.toFixed(format)}${plus ? '+' : ''}`;
  }

  return `${properties.currency} ${negative ? '-' : ''}${amount.toFixed(format)}${plus ? '+' : ''}`;
}

export function getPriceInfo(course, keys = []) {
  const obj = {};

  obj[keys[2]] = course[keys[2]] ? course[keys[2]] : 0;
  obj[keys[0]] = course[keys[0]] ? course[keys[0]] + obj[keys[2]] : 0;
  obj[keys[1]] = course[keys[1]] ? course[keys[1]] + obj[keys[2]] : 0;

  const { symbol, currency, showSymbol } = course;
  const amountProps = { symbol, currency, showSymbol };

  return keys.reduce((acc, key) => {
    if (key && course[key] !== undefined) {
      return {
        ...acc,
        [key]: obj[key],
        [`${key}Label`]: formatPrice(obj[key], amountProps),
        [`${key}OnlyLabel`]: formatPrice(course[key] ?? 0, amountProps),
      };
    }
    return acc;
  }, {});
}

export default formatPrice;
